import React from "react";
import UserTable from "./list/Userlist";
import "../../components/common/css/datatable.scss";
import "../../components/common/css/index.scss";

const Users = () => {
  
  return (
    <div className="list">
      <div className="listContainer">
        <UserTable/>
      </div>
    </div>
  );
};

export default Users;
